var storageName = 'testStorage';
export default storageName;